module.exports = __webpack_public_path__ + "img/companylogo5.0340c57e.png";